import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=bedf44b2&"
import script from "./Add.vue?vue&type=script&lang=ts&"
export * from "./Add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports